export const getWhatsAppLink = (phone?: string) => {
  if (!phone) return null;

  // Remove +, spaces, -, (), etc → keep only digits
  const cleaned = phone.replace(/\D/g, "");

  // WhatsApp requires country code + number
  // Most international numbers are 10–15 digits
  if (cleaned.length < 10 || cleaned.length > 15) {
    return null;
  }

  return `https://wa.me/${cleaned}`;
};
